export const en = {
  dueDate: 'DUE DATE:'
};

export type Translations = typeof en;
